




















import {Vue, Component} from 'vue-property-decorator'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import dataProxy from "@/services/data-proxy.service";
import {Podsetnik, PodsetnikVozila, PrimaocPodsetnika} from "@/services/BackendProxies";
import PodsetnikOsobeDialog from "@/views/Podsetnici/PodsetnikOsobeDialog.vue";
import PodsetnikVozilaDialog from "@/views/Podsetnici/PodsetnikVozilaDialog.vue";
import {formatDate} from "@/utils/formatters";
import _ from 'lodash';

declare const $: any;

@Component({components: {'mf-dialog-podsetnik-osobe': PodsetnikOsobeDialog, 'mf-dialog-podsetnik-vozila': PodsetnikVozilaDialog}})
export default class PregledPodsetnikaPoPrimaocima extends mixins(ComponentBaseMixin) {
    podsetnici = [];
    primaoci = [];
    tableOptions = {
        search: true,
        detailFormatter: this.detailFormatter,
        detailView: true
    };
    tableColumns = [];
    dialogVisibleOsobe = false;
    dialogVisibleVozilo = false;
    podsetnikOsobeRow = '';
    podsetnikVozilaRow = '';

    map: Map<string, Array<any>> = new Map();

    async created() {
        this.refresh();

        this.tableColumns = [
            {field: 'display',  title: this.$i18n.t('primaoc')},
        ]
    }

    detailFormatter(ix, primaocPodsetnika, element) {
        const podsetnici = this.map.get(primaocPodsetnika.display);
        const detailsTableId = `detailsTable_${ix}`;
        const $detailsTable = $(`<table class="${detailsTableId}"></table>`).bootstrapTable({
            columns: [
                {field: 'datum', title: this.$i18n.t('datum'), formatter: value => formatDate(value), width: 90},
                {field: 'opis', title: this.$i18n.t('opis'), formatter: value => value ? value : '', width: 230},
                {field: 'vozilo', title: this.$i18n.t('vozilo'),formatter: value => value ? value : '', width: 180},
                {field: 'osoba', title: this.$i18n.t('osoba'),formatter: value => value ? value : '', width: 180},
                {field: 'ukljucen', title: this.$i18n.t('ukljucen'), width: 30,
                    formatter: value => value ? this.$i18n.t('da') : this.$i18n.t('ne')}
            ],
            data: podsetnici,
            onClickRow: (row) => {
                if (row.osoba) {
                    this.podsetnikOsobeRow = {...row};
                    this.dialogVisibleOsobe = true;
                } else if (row.vozilo) {
                    this.podsetnikVozilaRow = {...row};
                    this.dialogVisibleVozilo = true;
                }
            }
        });
        $detailsTable.appendTo(element);
    }

    async osveziTabelu() {
        this.refresh();
    }

    async refresh() {

        const podsOsobe = await dataProxy.vratiPodsetnikeOsoba();
        const podsVozila = await dataProxy.vratiPodsetnikeVozila();

        this.podsetnici = [...podsOsobe, ...podsVozila];
        const self = this;

        this.map.clear();
        this.primaoci = [];
        this.podsetnici.forEach(x => {
            x.primaoci.forEach(p => {
                if (self.map.has(p.display)) {
                    const value = self.map.get(p.display);
                    value.push(x);
                } else {
                    self.map.set(p.display, [x]);
                }
            });
        });

        this.map.forEach(function(value, key) {
            self.primaoci.push({display: key});
        });
    }

}
